/* Public surface of the CodeBaby adapter.
 *
 * Consumers import from here, never from ./live or ./mock directly.
 * The mode is resolved at call time so swapping mock↔live is just a
 * URL param (?cb=mock | ?cb=live) or env var (VITE_CB_LOADER). */

import { loaderMode } from './config';
import { mountAvatarLive } from './live';
import { mountAvatarMock } from './mock';
import type { MountOptions, MountResult } from './types';

export type {
  AvatarSession,
  CoachMeta,
  CBClientData,
  CBLearner,
  CBLastSession,
  CBPersonaSignals,
  CBResponse,
  CBSavedMomentBrief,
  CBStartData,
  CBCheckInRubric,
  CBDebriefVerdict,
  LoaderMode,
  MicrophoneData,
  MountOptions,
  MountResult,
  PersonaId,
  ResponsePayload,
  SessionMode,
  StartData,
} from './types';
export { neutralClientData } from './types';

export { loaderMode } from './config';

export function mountAvatar(opts: MountOptions): MountResult {
  return loaderMode() === 'live' ? mountAvatarLive(opts) : mountAvatarMock(opts);
}

/** Test helper — explicit-mode mount for tests that don't want to
 *  depend on URL / env-var resolution. */
export function mountAvatarWithMode(mode: 'mock' | 'live', opts: MountOptions): MountResult {
  return mode === 'live' ? mountAvatarLive(opts) : mountAvatarMock(opts);
}
